// LoaderComponent.js
import React from "react";

import { Spinner } from "react-bootstrap";
import { useLoader } from "../../hooks";

const LoaderComponent = ({
  wantSpinner = true,
  label,
  mainStyle = {},
  spinnerStyle = {},
  children,
}) => {
  const { isLoading } = useLoader();

  return isLoading ? (
    <>
      <div
        className="loader"
        style={{
          ...mainStyle,
        }}
      >
        {wantSpinner && (
          <Spinner
            style={{
              width: "40px",
              height: "40px",
              borderWidth: 2,
              ...spinnerStyle,
            }}
          />
        )}
        {label && (
          <label style={{ fontSize: 14, color: "grey" }}>{label}</label>
        )}
      </div>
      {children}
    </>
  ) : (
    children
  );
};

export default LoaderComponent;
